{
  "name": "spri-angular",
  "version": "1.0.38",
  "description": "Steadman Philippon Research Institute Portal",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --host 0.0.0.0",
    "start:staging": "ng serve -o --configuration=staging",
    "start:production": "ng serve -o --configuration=production",
    "build": "ng build",
    "build:staging": "ng build --configuration=staging",
    "build:production": "ng build --configuration=production",
    "format": "prettier --write \"src/**/*.ts\" ",
    "watch": "ng build --watch --configuration staging",
    "test": "jest",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "test:cov": "jest --runInBand --coverage",
    "test:html": "jest --runInBand --coverage --coverageReport=html",
    "test:watch": "jest --watch",
    "test:ci": "jest --runInBand",
    "start:services": "bash start-services.sh",
    "logs": "tail -f logs/*.*",
    "prepare": "husky"
  },
  "dependencies": {
    "@angular/animations": "20.0.0",
    "@angular/cdk": "20.0.0",
    "@angular/common": "20.3.14",
    "@angular/compiler": "20.0.0",
    "@angular/core": "20.0.0",
    "@angular/forms": "20.0.0",
    "@angular/material": "20.0.0",
    "@angular/material-luxon-adapter": "20.0.0",
    "@angular/platform-browser": "20.0.0",
    "@angular/platform-browser-dynamic": "20.0.0",
    "@angular/router": "20.0.0",
    "@azure/msal-angular": "4.0.19",
    "@azure/msal-browser": "4.22.1",
    "@opentelemetry/api": "1.9.0",
    "@opentelemetry/context-zone": "2.1.0",
    "@opentelemetry/resources": "2.1.0",
    "@opentelemetry/sdk-trace-base": "2.1.0",
    "@opentelemetry/sdk-trace-web": "2.1.0",
    "apexcharts": "4.3.0",
    "crypto-js": "4.2.0",
    "flowbite": "^2.5.2",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.4",
    "jspdf-autotable": "^5.0.2",
    "lint-staged": "^16.2.3",
    "lodash-es": "4.17.21",
    "luxon": "3.5.0",
    "ng-apexcharts": "1.15.0",
    "ngx-mat-select-search": "^8.0.4",
    "ngx-quill": "27.0.0",
    "perfect-scrollbar": "1.5.6",
    "quill": "2.0.3",
    "rxjs": "7.8.1",
    "tslib": "2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.8",
    "@angular/cli": "20.0.0",
    "@angular/compiler-cli": "20.0.0",
    "@eslint/js": "^9.39.1",
    "@tailwindcss/typography": "0.5.15",
    "@types/chroma-js": "2.4.5",
    "@types/crypto-js": "4.2.2",
    "@types/jest": "^29.5.12",
    "@types/jspdf": "^1.3.3",
    "@types/lodash": "4.17.13",
    "@types/lodash-es": "4.17.12",
    "@types/luxon": "3.4.2",
    "angular-eslint": "20.2.0",
    "autoprefixer": "10.4.20",
    "baseline-browser-mapping": "^2.9.11",
    "chroma-js": "2.4.2",
    "eslint": "^9.33.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-sonarjs": "^3.0.5",
    "glob": "^11.1.0",
    "husky": "^9.1.7",
    "jest": "29.7.0",
    "jest-environment-jsdom": "^30.1.2",
    "jest-preset-angular": "^14.4.0",
    "lodash": "4.17.21",
    "postcss": "8.4.49",
    "prettier": "^3.4.2",
    "prettier-plugin-organize-imports": "4.1.0",
    "prettier-plugin-tailwindcss": "0.6.9",
    "tailwindcss": "3.4.17",
    "typescript": "5.8.2",
    "typescript-eslint": "8.40.0"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "prettier --write",
      "eslint --fix"
    ],
    "*.{json,md,scss,css}": [
      "prettier --write"
    ]
  }
}
